<style lang="scss">
.saveRolePermission {
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
<template>
  <div>
    <el-row>
      <el-col :span="18">
        <customize-page
          label-position="left"
          ref="page"
          inline
          :loading="loading"
          :data="dataList"
          :columns="columns"
          :pagination="pagination"
          :formConfig="getFormConfig()"
          :filterObj="filterObj"
          @on-current-change="handleTableCurrentChange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
          <div slot="footer">
            <el-button
              style="margin-right: 10px"
              type="primary"
              @click="search"
            >
              搜索
            </el-button>
            <el-button style="margin-right: 10px" @click="reset"
              >重置</el-button
            >
            <el-button
              v-hp="'add'"
              style="margin-right: 10px"
              type="primary"
              @click="showAddOrModifyView(null)"
            >
              新增
            </el-button>
          </div>
        </customize-page>
      </el-col>
      <el-col :span="6">
        <el-card
          :body-style="{
            'min-height': tableHeight + 'px',
            'max-height': tableHeight + 'px',
            overflow: 'auto',
          }"
        >
          <template slot="header">
            <div v-text="'《' + currentRole.name + '》菜单权限'"></div>
            <el-button
              v-hp="'savePermission'"
              size="mini"
              class="saveRolePermission"
              v-on:click="saveRolePermission()"
              >保存
            </el-button>
          </template>
          <el-tree
            ref="rolePermissionTree"
            empty-text="请选择左边角色"
            show-checkbox
            :data="permissionTree.permissionLitTree"
            node-key="id"
            :props="permissionTree.props"
            @check-change="treeCheckChange"
            :render-content="treeRenderContent"
            :check-strictly="true"
          >
          </el-tree>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      :title="(formData.id === 0 ? '新增' : '修改') + '角色'"
      width="450px"
      :visible.sync="showFormDialog"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="角色名">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="formData.description"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions } from "vuex";
import debounce from "lodash/debounce";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
    this.changeTableHeight();
    this.__resizeHandler = debounce(() => {
      this.changeTableHeight();
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },
  data() {
    return {
      tableHeight: 0,
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      operationItems: {},
      currentRole: { name: "请选择角色" },
      formData: {
        id: 0,
        name: "",
        description: "",
      },
      permissionTree: {
        permissionLitTree: [],
        props: {
          label: "name",
          children: "children",
        },
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "角色名",
          width: 160,
          fixed: "left",
          key: "name",
          align: "center",
        },
        {
          title: "描述",
          width: 160,
          fixed: "left",
          key: "description",
          align: "center",
        },
        {
          title: "修改时间",
          "min-width": 100,
          fixed: "left",
          key: "gmtModified",
          align: "center",
        },
        {
          title: "创建时间",
          "min-width": 100,
          fixed: "left",
          key: "gmtModified",
          align: "center",
        },
        {
          title: "操作",
          width: 120,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            let operation = [];
            if (this.$hasPermission(this.$route, "edit")) {
              operation.push(
                <el-button
                  type="text"
                  style="color:blue"
                  onClick={this.showAddOrModifyView.bind(this, data)}
                >
                  编缉
                </el-button>
              );
            }
            if (this.$hasPermission(this.$route, "delete")) {
              operation.push(
                <el-button
                  type="text"
                  style="color:blue"
                  onClick={this.delete.bind(this, data)}
                >
                  删除
                </el-button>
              );
            }
            return <div>{operation}</div>;
          },
        },
      ],
      filterObj: {
        roleName: "",
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions("roleStore", {
      addOrUpdateRole: "addOrUpdateRole",
      listRole: "listRole",
      deleteRole: "deleteRole",
    }),
    ...mapActions("permissionStore", {
      listRolePermission: "listRolePermission",
    }),
    ...mapActions("rolePermissionStore", {
      roleBindPermission: "roleBindPermission",
    }),
    handleTableCurrentChange(val) {
      this.permissionTree.permissionLitTree = [];
      this.operationItems = {};
      if (val == null) {
        this.currentRole = { name: "请选择角色" };
        return;
      }
      let loading = this.$loading({
        target: this.$refs.rolePermissionTree.$el,
      });
      this.currentRole = val;
      this.listRolePermission({
        request: JSON.stringify({ isGetCacheDta: false, roleIds: [val.id] }),
      }).then((res) => {
        this.permissionTree.permissionLitTree = res.items || [];
        this.operationItems = {};
        let stackTemp = [];
        stackTemp.push(...res.items);
        let currentItem;
        let checkedKeys = [];
        while (
          stackTemp.length > 0 &&
          (currentItem = stackTemp.pop()) != null
        ) {
          if (currentItem.roleIsPermission === true) {
            checkedKeys.push(currentItem.id);
          }
          if (null != currentItem.children) {
            stackTemp.push(...currentItem.children);
          }
        }
        this.$refs.rolePermissionTree.setCheckedKeys(checkedKeys);
        loading.close();
      });
    },
    // 更新品牌列表
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        }),
      };

      this.listRole(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          this.pagination.totalCount = res.dataTotal || 0;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    showAddOrModifyView(data) {
      if (data != null) {
        this.formData.id = data.id;
        this.formData.name = data.name;
        this.formData.description = data.description;
      } else {
        this.formData = JSON.parse(this.defaultFormData);
      }
      this.showFormDialog = !this.showFormDialog;
    },
    save() {
      this.addOrUpdateRole({ request: JSON.stringify(this.formData) }).then(
        (res) => {
          if (res.value) {
            this.showFormDialog = !this.showFormDialog;
            this.fetch();
            this.$message.success("保存成功");
          } else {
            this.$message.error("保存失败");
          }
        }
      );
    },
    delete(param) {
      this.$confirm("确认删除？", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteRole({ request: JSON.stringify({ id: param.id }) }).then(
          (res) => {
            if (res.value) {
              this.fetch();
              this.$message.success("删除成功");
            } else {
              this.$message.error("删除失败");
            }
          }
        );
      });
    },
    treeRenderContent(h, { node, data, store }) {
      //this.$refs.rolePermissionTree.setChecked(data, node.roleIsPermission);
      let iconClass = "el-icon-menu";
      if (data.type === 2) {
        iconClass = "el-icon-document";
      }
      if (data.type === 4) {
        iconClass = "el-icon-thumb";
      }
      return (
        <span className="custom-tree-node">
          <i class={iconClass}></i>
          <span>{node.label}</span>
        </span>
      );
    },
    treeCheckChange(data, nodeCheck, childrenCheck) {
      if (nodeCheck === true) {
        let currentServerCheck = data.roleIsPermission === true;
        if (currentServerCheck) {
          delete this.operationItems[data.id];
        } else {
          this.operationItems[data.id] = 1;
        }
        let currentNode = this.$refs.rolePermissionTree.getNode(data.id);
        let parentNode;
        while (
          currentNode.level > 1 &&
          (parentNode = currentNode.parent) != null
        ) {
          if (!parentNode.checked) {
            parentNode.checked = true;
            if (parentNode.data.roleIsPermission === true) {
              delete this.operationItems[parentNode.key];
            } else {
              this.operationItems[parentNode.key] = 1;
            }
          }
          currentNode = parentNode;
        }
      } else {
        if (data.roleIsPermission === true) {
          this.operationItems[data.id] = 0;
        } else {
          delete this.operationItems[data.id];
        }
        let currentNode = this.$refs.rolePermissionTree.getNode(data.id);

        if (
          currentNode.childNodes != null &&
          currentNode.childNodes.length > 0
        ) {
          let tempStack = [...currentNode.childNodes];
          let currentChild;
          while ((currentChild = tempStack.pop()) != null) {
            if (currentChild.checked) {
              currentChild.checked = false;
              if (currentChild.data.roleIsPermission === false) {
                delete this.operationItems[currentChild.key];
              } else {
                this.operationItems[currentChild.key] = 0;
              }
            } else {
              continue;
            }
            if (
              currentChild.childNodes != null &&
              currentChild.childNodes.length > 0
            ) {
              tempStack.push(...currentChild.childNodes);
            }
          }
        }
      }
    },
    saveRolePermission() {
      let operationItems = [];
      for (let permissionId in this.operationItems) {
        operationItems.push({
          permissionId,
          operation: this.operationItems[permissionId],
        });
      }
      this.roleBindPermission({
        request: JSON.stringify({
          roleId: this.currentRole.id,
          operationItems: operationItems,
        }),
      }).then((res) => {
        if (res.value) {
          this.handleTableCurrentChange(this.currentRole);
          this.$message.success("成功");
        } else {
          this.$message.error("失败");
        }
      });
    },
    changeTableHeight() {
      this.$nextTick(() => {
        const wHeight = window.innerHeight;
        const cardHeaderHeight = 59;
        const cardHeight = wHeight - 48 - 56 - 10;
        const innerHeight = cardHeight - cardHeaderHeight;
        const tableHeight = innerHeight;
        this.tableHeight = tableHeight > 300 ? tableHeight : 300;
      });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "角色名",
              model: "roleName",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
  },
};
</script>
